import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Button } from 'carbon-components-react';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const ListBadges = makeShortcode("ListBadges");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const ImageGallery = makeShortcode("ImageGallery");
const ImageGalleryImage = makeShortcode("ImageGalleryImage");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`I write mystery novels, humor, science fiction and fantasy, and even kids’ books.`}</p>
    </PageDescription>
    <ListBadges frontmatter={props.pageContext.frontmatter} mdxType="ListBadges" />
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Mystery Novels</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Science Fiction and Fantasy</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Kids' Books</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Humor</AnchorLink>
    </AnchorLinks>
    <h2>{`Mystery Novels`}</h2>
    <p>{`I’ve launched two separate cozy mystery series:`}</p>
    <ul>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "https://www.amazon.com/dp/B07XXCXTH5"
        }}>{`Empath Detective`}</a>{` comedy series`}</li>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "https://www.amazon.com/dp/B07X8C6QYS"
        }}>{`Wonder Springs`}</a>{` psychic series.`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://billalive.com/ahv"
      }}>{`The Affair of the Hideous Vase`}</a>{` is a standalone.`}</p>
    <Button kind='tertiary' href="https://www.amazon.com/dp/B07XXCXTH5" mdxType="Button">Empath Detective Mysteries</Button>
    <Button kind='tertiary' href="https://www.amazon.com/dp/B07X8C6QYS" mdxType="Button">Wonder Springs Mysteries</Button>
    <Button kind='tertiary' href="https://billalive.com/ahv" mdxType="Button">The Affair of the Hideous Vase</Button>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Murder Feels Awful" title="Murder Feels Awful" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBAgQF/8QAFwEAAwEAAAAAAAAAAAAAAAAAAgMEAP/aAAwDAQACEAMQAAABQ6rBs5xrMzPC4OOxAL//xAAcEAACAgIDAAAAAAAAAAAAAAABAgMRABITISL/2gAIAQEAAQUCiRCNI8KgmPpr2LQspaRgFkOgdgKvOPyFNf/EABgRAAMBAQAAAAAAAAAAAAAAAAABEQIS/9oACAEDAQE/AdYVOcFdFT//xAAXEQADAQAAAAAAAAAAAAAAAAAAECER/9oACAECAQE/AdUIf//EABwQAAEEAwEAAAAAAAAAAAAAAAABEBEhAhIxMv/aAAgBAQAGPwKFfkmkdbG+FqVkpEoekb//xAAcEAEBAQEAAwEBAAAAAAAAAAABEQAhMUFhUXH/2gAIAQEAAT8hQF313J+T691YlxqYtw7waAg/R01oV8+deHnU726eAf3euAdrj8Mllzq3/9oADAMBAAIAAwAAABDD03D/xAAZEQEAAwEBAAAAAAAAAAAAAAABABEhMYH/2gAIAQMBAT8Q1DnkFLKiXcVMJ//EABcRAAMBAAAAAAAAAAAAAAAAAAABEVH/2gAIAQIBAT8QSlJkbwf/xAAfEAEBAAICAwADAAAAAAAAAAABEQAhMVFBYXGBkbH/2gAIAQEAAT8QU29aANePrioqAGxxq/3HnolvGUiyBPBu764xIVaTo/P6yk0lKhyhdM1LjH1rL1t1XBAv3N4Qs7YnUj4Y7kO5cRDchyfJ3huEu9jn/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Murder Feels Awful",
            "title": "Murder Feels Awful",
            "src": "/static/0dba9dbff0d68c777f40d3a2cc890cf8/2e753/mfa.jpg",
            "srcSet": ["/static/0dba9dbff0d68c777f40d3a2cc890cf8/69549/mfa.jpg 288w", "/static/0dba9dbff0d68c777f40d3a2cc890cf8/473e3/mfa.jpg 576w", "/static/0dba9dbff0d68c777f40d3a2cc890cf8/2e753/mfa.jpg 1152w", "/static/0dba9dbff0d68c777f40d3a2cc890cf8/490e5/mfa.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Murder Feels Bad" title="Murder Feels Bad" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAID/9oADAMBAAIQAxAAAAHPaNLzwlxkXM8GCCH/xAAdEAACAwACAwAAAAAAAAAAAAABAgADEhETIiMx/9oACAEBAAEFAqlQjFQhUE1qdsdw1ssexxOz17MHlOOUHz//xAAZEQACAwEAAAAAAAAAAAAAAAAAEQEQIUH/2gAIAQMBAT8B4ORZX//EABkRAQACAwAAAAAAAAAAAAAAAAEAEhARIf/aAAgBAgEBPwGpuVIPcf/EABwQAAEEAwEAAAAAAAAAAAAAAAEAEBEhAhMxUf/aAAgBAQAGPwKD1wtYFyw8CxviqVEoXi3/xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMUFRYXH/2gAIAQEAAT8hUF4zHcMbcyyVcswXTHQsVNxykvpGejOe5oWAbXMA2p9iu0lZyziLF7jj/9oADAMBAAIAAwAAABBHwn//xAAZEQEBAAMBAAAAAAAAAAAAAAABABEhMWH/2gAIAQMBAT8QMmTekLSXfL//xAAXEQEBAQEAAAAAAAAAAAAAAAABABFR/9oACAECAQE/EFMEPAJYXt//xAAfEAEAAgICAgMAAAAAAAAAAAABABEhMUFRYbFxkfD/2gAIAQEAAT8Qd0jigDHHyxAVACK1i/cbLwPiXIgbvA816m8lTtWH94h0BS7ISYmjepb6MvXQARs5LglU+rhmR9UOax9xqmrQb84ruEjU/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Murder Feels Bad",
            "title": "Murder Feels Bad",
            "src": "/static/6f4f499fdea8ef61f0f23e73fd1d681e/2e753/mfb.jpg",
            "srcSet": ["/static/6f4f499fdea8ef61f0f23e73fd1d681e/69549/mfb.jpg 288w", "/static/6f4f499fdea8ef61f0f23e73fd1d681e/473e3/mfb.jpg 576w", "/static/6f4f499fdea8ef61f0f23e73fd1d681e/2e753/mfb.jpg 1152w", "/static/6f4f499fdea8ef61f0f23e73fd1d681e/490e5/mfb.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Murder Feels Crazy" title="Murder Feels Crazy" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABYBAQEBAAAAAAAAAAAAAAAAAAIAAf/aAAwDAQACEAMQAAABjejYcI8sa+TdOIQP/8QAGxABAAMBAQEBAAAAAAAAAAAAAQACAxIREyH/2gAIAQEAAQUCxKpzmR8XEeu28vhejfR8xVFpCvc+f4k//8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAwEBPwHFaU//xAAZEQABBQAAAAAAAAAAAAAAAAAAAQIQERL/2gAIAQIBAT8Bh2VKP//EAB4QAAICAgIDAAAAAAAAAAAAAAABAjEQESJBMmGR/9oACAEBAAY/AtO+s0KKi9yNNEfRzdI7+lnmsf/EAB4QAAIDAAIDAQAAAAAAAAAAAAERACExQZFRYXGx/9oACAEBAAE/IS7vId2ab4gMbAzN0H1GU4QB/ZZ58LnvDBOoI0ZGAGu8JoiF5gJDwY5ZP//aAAwDAQACAAMAAAAQUPj9/8QAGBEBAQADAAAAAAAAAAAAAAAAAQARIXH/2gAIAQMBAT8QwWoELcX/xAAYEQEBAAMAAAAAAAAAAAAAAAABABAhcf/aAAgBAgEBPxDeGCF3f//EAB4QAQACAgMBAQEAAAAAAAAAAAEAESExQVFxoYGR/9oACAEBAAE/ELDEvQBjj1jQhADK6X+5jJeF6hu2tsCkKZ7qJiFUtNlHxnyVFKrGokzhWiSEI2v9+RSq4DdXe+4pGhbvMyoRm75aJjwG3J57NpyvNz//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Murder Feels Crazy",
            "title": "Murder Feels Crazy",
            "src": "/static/b8edb017d46d5673b6f57bd14f59f41b/2e753/mfc.jpg",
            "srcSet": ["/static/b8edb017d46d5673b6f57bd14f59f41b/69549/mfc.jpg 288w", "/static/b8edb017d46d5673b6f57bd14f59f41b/473e3/mfc.jpg 576w", "/static/b8edb017d46d5673b6f57bd14f59f41b/2e753/mfc.jpg 1152w", "/static/b8edb017d46d5673b6f57bd14f59f41b/490e5/mfc.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="High-Rise Demise" title="High-Rise Demise" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAH/xAAXAQADAQAAAAAAAAAAAAAAAAAAAQID/9oADAMBAAIQAxAAAAHLRHrPCaBqFZcm2LCP/8QAHBAAAgMBAAMAAAAAAAAAAAAAAQIAAxITBBEh/9oACAEBAAEFAkrVk4iOBqv2FDs5NU2YbdNqciG5/E8RnX//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPwGqiP/EABYRAQEBAAAAAAAAAAAAAAAAABEAEP/aAAgBAgEBPwE1v//EAB8QAAICAgEFAAAAAAAAAAAAAAABAhEhMWESMlFxof/aAAgBAQAGPwLudjzLZjJL6JK3ZxwNeRvRixxk6L60W5KPs//EABwQAAIDAAMBAAAAAAAAAAAAAAERACExQVFhcf/aAAgBAQABPyEeSAsdRdug6Yj9k7lUGB24gwiUDMODVlhJwntCQXxNFb2IKo+wjwIBsnYD8FpwVdsGp//aAAwDAQACAAMAAAAQqDQC/8QAGBEBAQADAAAAAAAAAAAAAAAAEQAQITH/2gAIAQMBAT8QRuVwYf/EABkRAAIDAQAAAAAAAAAAAAAAAAAhEBExQf/aAAgBAgEBPxDSEX2H/8QAHhAAAgIDAQADAAAAAAAAAAAAAREAITFBcVFhodH/2gAIAQEAAT8QJagUQvp4ICFiSqg3Y7FZeAnbr9glK36h4bB+ZiJlGDqxHcUGokYz0GCSCUEkjeuXBa7FB0Vd+OZYAQOPwKAEoEHfsKEgOxbnZnGNtho1P//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "High-Rise Demise",
            "title": "High-Rise Demise",
            "src": "/static/456e34c7158a5e93114ad6da2a51e78c/2e753/hrd.jpg",
            "srcSet": ["/static/456e34c7158a5e93114ad6da2a51e78c/69549/hrd.jpg 288w", "/static/456e34c7158a5e93114ad6da2a51e78c/473e3/hrd.jpg 576w", "/static/456e34c7158a5e93114ad6da2a51e78c/2e753/hrd.jpg 1152w", "/static/456e34c7158a5e93114ad6da2a51e78c/490e5/hrd.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Murder With a Psychic Touch" title="Murder With a Psychic Touch" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAv/EABcBAQEBAQAAAAAAAAAAAAAAAAIDAAH/2gAMAwEAAhADEAAAAZu3d9EcbGaZHxGjQqLf/8QAGhABAAMBAQEAAAAAAAAAAAAAAQIDEQASFP/aAAgBAQABBQKNEpHzvTq8oeeXDN4RqbIeXDo2OM3W97//xAAaEQEAAQUAAAAAAAAAAAAAAAABAAIQEiEx/9oACAEDAQE/AatdmTELf//EABgRAAMBAQAAAAAAAAAAAAAAAAABETEQ/9oACAECAQE/AdwiFef/xAAeEAACAQQDAQAAAAAAAAAAAAAAASEQERIxAmGBcf/aAAgBAQAGPwK6sbRs9qnOjHFPukYr6yeS8IP/xAAcEAADAAMBAQEAAAAAAAAAAAAAAREhMUFRYXH/2gAIAQEAAT8hScE9gbGCS5zEnBbWro6LJDHpkmIy8PTJTHv8JvwBJ3emjSH/2gAMAwEAAgADAAAAEMQP8//EABgRAAIDAAAAAAAAAAAAAAAAABARASEx/9oACAEDAQE/EGVwyr0f/8QAGBEBAQEBAQAAAAAAAAAAAAAAAQARIVH/2gAIAQIBAT8QEXF6y0jywv/EAB4QAQEAAgICAwAAAAAAAAAAAAERACExYUFRcYHR/9oACAEBAAE/EEkKELzr3gRzjnj8xLZQdd45aQBWEUb85ueGlO8huheTFCyEIdpqT6wBIKGz2L4NZoujlLFzX7XWE7nrNMEeRDpwklDilz//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Murder With a Psychic Touch",
            "title": "Murder With a Psychic Touch",
            "src": "/static/ae15b201f0c6fdfa6191df8fe5e45fd1/2e753/wsms-1.jpg",
            "srcSet": ["/static/ae15b201f0c6fdfa6191df8fe5e45fd1/69549/wsms-1.jpg 288w", "/static/ae15b201f0c6fdfa6191df8fe5e45fd1/473e3/wsms-1.jpg 576w", "/static/ae15b201f0c6fdfa6191df8fe5e45fd1/2e753/wsms-1.jpg 1152w", "/static/ae15b201f0c6fdfa6191df8fe5e45fd1/490e5/wsms-1.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Murder With a Psychic Zap" title="Murder With a Psychic Zap" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBBAUC/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/2gAMAwEAAhADEAAAAczp8h0BxY2buZMWwaIf/8QAHRAAAgEEAwAAAAAAAAAAAAAAAQIDABESExQhIv/aAAgBAQABBQIQsRoNNHYjzEz9EWKlcWKCOzmkmOMcus8xFr//xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQEv/aAAgBAwEBPwHmY2in/8QAGREAAgMBAAAAAAAAAAAAAAAAACEQERIi/9oACAECAQE/AerRkcf/xAAgEAACAgEDBQAAAAAAAAAAAAAAAREhMQISIjNBUWGB/9oACAEBAAY/ApUGUZE1kosVX7FwWt9zpplbfpyi/BSk/8QAHRABAAMAAgMBAAAAAAAAAAAAAQARITFBUWFxkf/aAAgBAQABPyE1hnkg9dJoW3slAXvuNRyjdmNdH5CcY5cV8nWEeIUlPWoKCwznXqKETvdVP//aAAwDAQACAAMAAAAQPD9B/8QAGREAAwEBAQAAAAAAAAAAAAAAAAERITFB/9oACAEDAQE/EH6EvB6Rj1h//8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERIVH/2gAIAQIBAT8QrcKJJonvIJuaj//EAB8QAQADAAEFAQEAAAAAAAAAAAEAESExQVFhcdGBwf/aAAgBAQABPxBnCii+c7wLrDnj5NlLBzzBc9kSwA0/YimLMYniNQOrNIcA1KrfcDsjl6EauEBFnf8AsECxfvO2xRM1Y0eQwCctjSvq8n//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Murder With a Psychic Zap",
            "title": "Murder With a Psychic Zap",
            "src": "/static/ce1fd473c7100ef9943f3a8d79824394/2e753/wsms-2.jpg",
            "srcSet": ["/static/ce1fd473c7100ef9943f3a8d79824394/69549/wsms-2.jpg 288w", "/static/ce1fd473c7100ef9943f3a8d79824394/473e3/wsms-2.jpg 576w", "/static/ce1fd473c7100ef9943f3a8d79824394/2e753/wsms-2.jpg 1152w", "/static/ce1fd473c7100ef9943f3a8d79824394/490e5/wsms-2.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Murder With a Psychic Kiss" title="Murder With a Psychic Kiss" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEBQb/xAAXAQEBAQEAAAAAAAAAAAAAAAACAwEE/9oADAMBAAIQAxAAAAHPda+PVhmiFNs5ihQqIRZ//8QAHBABAQACAwEBAAAAAAAAAAAAAQIAEgMEERMU/9oACAEBAAEFAp69Ufly+ujKEU+HsuDOpJrXEbC1hz1OfYz/xAAaEQACAgMAAAAAAAAAAAAAAAAAEgECAxEx/9oACAEDAQE/AVrAmMbXBj//xAAXEQADAQAAAAAAAAAAAAAAAAAAAhIR/9oACAECAQE/AaLYjDWP/8QAHRAAAgEEAwAAAAAAAAAAAAAAAAERAiExgRBCUf/aAAgBAQAGPwKVBdmSmFckyL0bbOxMrbIbWuP/xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhQTFRgaH/2gAIAQEAAT8hP4MHolLBBym1LAcPyZmEvGewxF0A1mMSHipxDVhwJMtm3yf/2gAMAwEAAgADAAAAEDDvT//EABgRAQEBAQEAAAAAAAAAAAAAAAEAESHB/9oACAEDAQE/EDsyH77AGKxf/8QAGREBAQADAQAAAAAAAAAAAAAAAQARITFh/9oACAECAQE/EFvJLUv1AGC//8QAHxABAAICAwADAQAAAAAAAAAAAQARITFBUWFxodHh/9oACAEBAAE/EFkLKF3jshzb51+RKkIOu4q9Maq828RyVHysgpGNrLUpziWUL/IBS2OqVIS3SAfcCLRmint8gI+N28HjBqj0j//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Murder With a Psychic Kiss",
            "title": "Murder With a Psychic Kiss",
            "src": "/static/bd71e0bb48b525efe01c9bc11813c8c1/2e753/wsms-3.jpg",
            "srcSet": ["/static/bd71e0bb48b525efe01c9bc11813c8c1/69549/wsms-3.jpg 288w", "/static/bd71e0bb48b525efe01c9bc11813c8c1/473e3/wsms-3.jpg 576w", "/static/bd71e0bb48b525efe01c9bc11813c8c1/2e753/wsms-3.jpg 1152w", "/static/bd71e0bb48b525efe01c9bc11813c8c1/490e5/wsms-3.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Affair of the Hideous Vase" title="Murder Feels Crazy" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "154.5138888888889%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIDBAUB/8QAFgEBAQEAAAAAAAAAAAAAAAAAAwIE/9oADAMBAAIQAxAAAAGvGsYXojiastuy1mrjjN//xAAcEAACAgIDAAAAAAAAAAAAAAABAgADERIEEyH/2gAIAQEAAQUCsvYOvI2Pa4lQjoNnsVSLDXDloGWeOcjWf//EABkRAAIDAQAAAAAAAAAAAAAAAAABERMhMv/aAAgBAwEBPwHWYcuGVn//xAAcEQACAgIDAAAAAAAAAAAAAAAAAQIRAxITMWL/2gAIAQIBAT8BUY9Cx+CtJWjlR//EACEQAAICAAUFAAAAAAAAAAAAAAABERICECEigTEyQVGR/9oACAEBAAY/AoawkVUs7V8Jrr7FGwh9Sr4LeDdhnk1Iby//xAAcEAEAAwADAQEAAAAAAAAAAAABABEhMUFRYbH/2gAIAQEAAT8hXhAXhHBWFYRzRYF5y+pTB232YPAaSwtT8SlvfBekAaP3EqpkeKhrF953KJ//2gAMAwEAAgADAAAAEBzZvP/EABkRAAMBAQEAAAAAAAAAAAAAAAABESFBUf/aAAgBAwEBPxB0qFng83len//EAB0RAAICAQUAAAAAAAAAAAAAAAABESExQWGBkfD/2gAIAQIBAT8Qxqv25KtXDKirG5zD7Z//xAAeEAEBAAICAgMAAAAAAAAAAAABEQAhQWEx8JGxwf/aAAgBAQABPxCQSIRV7jpwJ8I2n3jQGJqN/cW3syBeMY9AiyiNjrDACADw5EJiIZdo98Y38VUUNbxsK27cVLgqG77XLiA8DQ9TGmw+M//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Affair of the Hideous Vase",
            "title": "Affair of the Hideous Vase",
            "src": "/static/4f99b1c68464316348d1e71bab22681e/2e753/ahv.jpg",
            "srcSet": ["/static/4f99b1c68464316348d1e71bab22681e/69549/ahv.jpg 288w", "/static/4f99b1c68464316348d1e71bab22681e/473e3/ahv.jpg 576w", "/static/4f99b1c68464316348d1e71bab22681e/2e753/ahv.jpg 1152w", "/static/4f99b1c68464316348d1e71bab22681e/cc4ba/ahv.jpg 1650w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <h2>{`Science Fiction and Fantasy`}</h2>
    <Row mdxType="Row">
      <Column colMd={9} colLg={9} mdxType="Column">
        <h3>{`The Punctuality Machine, Or, A Steampunk Libretto`}</h3>
        <p>{`My steampunk comedy mashup of aliens and time travel first appeared in
`}<a parentName="p" {...{
            "href": "https://www.beneath-ceaseless-skies.com/stories/the-punctuality-machine-or-a-steampunk-libretto/"
          }}><em parentName="a">{`Beneath Ceaseless Skies`}</em>{`, Issue
#173`}</a>{`.
(BCS is a professional, Qualifying Market for `}<a parentName="p" {...{
            "href": "https://www.sfwa.org/about/join-us/sfwa-membership-requirements/"
          }}>{`SFWA
membership`}</a>{`.)`}</p>
        <p>{`The story was later chosen for a special large-cast reading for the BCS podcast. You can `}<a parentName="p" {...{
            "href": "https://www.beneath-ceaseless-skies.com/audio/bcs-150-the-punctuality-machine-or-a-steampunk-libretto/"
          }}>{`hear the full episode here`}</a>{`. The lead voice actors were fantastic, and I got to play multiple characters, which was a blast.`}</p>
        <p>{`To our delight, that performance was a `}<a parentName="p" {...{
            "href": "http://www.parsecawards.com/2015-parsec-awards/2016-parsec-awards-finalists/"
          }}>{`2016 Parsec Award Finalist`}</a>{` for Best Speculative Fiction Story: Large Cast.`}</p>
        <p>{`I’ve also `}<strong parentName="p">{`directed two live performances`}</strong>{` of this comedy: a very fun off-the-cuff reading at a Capclave conference with fellow SF authors, and a full-blown production (months of rehearsals) with my children’s co-op.`}</p>
        <p>{`The reading led to a fun `}<a parentName="p" {...{
            "href": "https://weightlessbooks.com/beneath-ceaseless-skies-author-interview-bill-powell/"
          }}>{`interview with Weightless Books`}</a>{`.`}</p>
        <p>{`Finally, this is the feature story in my short story collection, `}<a parentName="p" {...{
            "href": "https://www.amazon.com/gp/product/B07PBXXHJB"
          }}><em parentName="a">{`The Punctuality Machine: And Other Tales of Time Dysfunction`}</em></a>{`.`}</p>
        <Button size='md' kind='tertiary' href="https://www.beneath-ceaseless-skies.com/audio/bcs-150-the-punctuality-machine-or-a-steampunk-libretto/" mdxType="Button">Hear the performance</Button>
        <Button size='md' kind='tertiary' href="https://www.amazon.com/gp/product/B07PBXXHJB" mdxType="Button">Get the book</Button>
      </Column>
      <Column colMd={3} colLg={3} mdxType="Column">
        <ImageGallery mdxType="ImageGallery">
          <ImageGalleryImage alt="BCS Issue #173" title="BCS Issue #173" col={4} mdxType="ImageGalleryImage">
            <span {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "750px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "133.33333333333331%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGzS0nTOEWKRTXNzGA//8QAHBAAAgICAwAAAAAAAAAAAAAAAAECEQMQEiEx/9oACAEBAAEFAn7Do5RLUnLIojytu9UxC1//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAXEQEAAwAAAAAAAAAAAAAAAAAAEBES/9oACAECAQE/AY0t/8QAGBAAAwEBAAAAAAAAAAAAAAAAICExABD/2gAIAQEABj8CXHqFH//EABsQAAICAwEAAAAAAAAAAAAAAAABESExQVFh/9oACAEBAAE/IVSVbMlc4rOCZsZZNpJLbLbi0nizIq6Gf//aAAwDAQACAAMAAAAQmP1z/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAwEBPxB5CH//xAAXEQEBAQEAAAAAAAAAAAAAAAAAEQEh/9oACAECAQE/EMRwt//EAB4QAQACAQUBAQAAAAAAAAAAAAEAESExQVFhcYGR/9oACAEBAAE/EAIB8JeLAH2cILL3DA1Gi2BJ2qcXHN4bEtWmey16FqaXG2AEjmJcTXDmK3b8n//Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "BCS Issue #173",
                "title": "BCS Issue #173",
                "src": "/static/362920530027ce32f2b6190a1c07c357/10729/beneath-ceaseless-skies-issue-173-cover.jpg",
                "srcSet": ["/static/362920530027ce32f2b6190a1c07c357/69549/beneath-ceaseless-skies-issue-173-cover.jpg 288w", "/static/362920530027ce32f2b6190a1c07c357/473e3/beneath-ceaseless-skies-issue-173-cover.jpg 576w", "/static/362920530027ce32f2b6190a1c07c357/10729/beneath-ceaseless-skies-issue-173-cover.jpg 750w"],
                "sizes": "(max-width: 750px) 100vw, 750px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy",
                "decoding": "async"
              }}></img>{`
    `}</span>
          </ImageGalleryImage>
          <ImageGalleryImage alt="Catalyst" title="Catalyst" col={4} mdxType="ImageGalleryImage">
            <span {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1003px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "119.79166666666667%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAACXBIWXMAAC4jAAAuIwF4pT92AAADxUlEQVQ4y9WU7W9UVRDGf3POnHv37nZbu21ZsLUtWEtp60t5K1ha2hJaqEhIlSBojU0wEsUXhN3WlqgxUQtq/Ch8AHV3CzbwwZgQ04TURv8B4z+05ty7IHzDb3qSJ+feczLPPDNnZuB/tcpzhnJRKBcN5TmRa5+m+HFRKM0b2q6e5uzFs49GdOXaLFeuz3qSGmGCGxeIzyoFWD4P5Y/0EZUV4XoBSkXD74v+32TKc9J98x7hBVg+9y8Jvy8Iy964GIeeqRSZrMxLqjxnWm6eA4/SgnsENnG8+YIFrEADlTmer8zxrA+zXOBEqcDHP1+EC9NIPqeCKMj93dtLjAcJq1XAKEPb8Aq/qBSZv70A619JfXWV7KlxA4T8Q1IDLrZPvv0yCSGEYqz2gW76chYuveWClQWOt+dtI7jubEbrwIWI60M0g2gXom02duJ6EddTU5cQinXNoFNP5HWmcFzeWFlg/tYid3o77WQQ6EGMjmDcFKJ7EG1B3OuI5hEdRnQvolsQtYlS49DANYK+6gIdvvoedypF/rq1yNqHL8lKNqOnER1Qp02IHsKoV/QK4jzhMW+fpMBynzAMXRPoRLVKcGOe78oFVm9fZHVvnz0Krt+qjiHagegI4hW7F7FBM6L7EZ2IQxarCaEoHXlVCKJz02bL57PS8+4xk//hPJ98MG26IRUEQRxeK8b58NIY141xQ4j1YfYiuhuN7r2yilVFVTeBHgbXC26zV9bVartAd2D0MKIpRI8gbkctl9sRHUL0AKJb49A9EplxGYyJcSdUdZ+qTojRGdBRMTqO0ZNidGeyu0H/SEFgo+TO7YzTIDaM81irKe/9SSAD2gGuC1wn6FOgLb7qwT4NphXsRtAe0AFwbWDziPWKXS2HDhEXYtKt1j2Wz9W78Vy9Hc3V637ndDQMdKypIRzKRNEuazP9quGgL6VMpJP5nB2zGoxgsq1GQ4vxeQzryDWlLDTsTqVSl4/usX+8Nm7XD263ay/vs+uDPfrrzAH95Z0j+tOZKS2dGrV3926zd0+OmrXJHfa3KEqfQeqOBKkoQtMPNnX6UBi6rwd77OVntuil1hZd2tmtS483BwvbOsL3x58L3961VT/b3WO/GejSpe1d+m3npvC0uOwubGZEwjqHq/NEOaCFVOhLRw20C2wQqBPoFRiIez3udzoENgvkBTZK9U9/5sRoIKASPy7SDvT74k5yTyOQBaKasw3AVqCEn0ZQX0O25iSN1TAZFDGGq7VBkeJ+LT0Efx6BSYMJHr6zEfi5Yf1dmOA/v/4GmjypHuGIbUwAAAAASUVORK5CYII=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Parsec Finalist",
                "title": "Parsec Finalist",
                "src": "/static/e420b538916fa17b9a160bdb76fc3ae1/a9c44/parsec-finalist-2016.png",
                "srcSet": ["/static/e420b538916fa17b9a160bdb76fc3ae1/7fc1e/parsec-finalist-2016.png 288w", "/static/e420b538916fa17b9a160bdb76fc3ae1/a5df1/parsec-finalist-2016.png 576w", "/static/e420b538916fa17b9a160bdb76fc3ae1/a9c44/parsec-finalist-2016.png 1003w"],
                "sizes": "(max-width: 1003px) 100vw, 1003px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy",
                "decoding": "async"
              }}></img>{`
    `}</span>
          </ImageGalleryImage>
          <ImageGalleryImage alt="Catalyst" title="Catalyst" col={4} mdxType="ImageGalleryImage">
            <span {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "792px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "150%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAFW8r4WTURGldBaOeV//8QAHBAAAgMAAwEAAAAAAAAAAAAAAAECAxEEEiET/9oACAEBAAEFAvl1b9HVbyHbLtL1CueSnpopaotGxNw//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFhEAAwAAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/AXD/xAAeEAACAgICAwAAAAAAAAAAAAAAAREhAhASQTJRgf/aAAgBAQAGPwKG7XR6+HNRBKLdELHGFvxRZ3r/xAAcEAEBAQADAQEBAAAAAAAAAAABEQAhMUFRkeH/2gAIAQEAAT8h5UfdFxkTgfMmFdKs3OSPVuqRn0XRBuCL/d6Ap1Mi1Ge4rGyK3fprET95pN//2gAMAwEAAgADAAAAEFffvP/EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAwEBPxB0/8QAFxEBAQEBAAAAAAAAAAAAAAAAAREAEP/aAAgBAgEBPxBq4gTk7//EAB4QAQEAAgIDAQEAAAAAAAAAAAERACExUUFhgXGR/9oACAEBAAE/ELK/P8db8jgxlCqn9zWNg7CdW9481O/TmbL8xqKdS3AmglBPRprKQFoQ2/s5yABXIX5vCwAQiD494JDXCRMoqanCesbB/9k=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Punctuality Collection",
                "title": "Punctuality Collection",
                "src": "/static/7f4b1a82e885bd6ab855e798943816bc/8c352/punctuality.jpg",
                "srcSet": ["/static/7f4b1a82e885bd6ab855e798943816bc/69549/punctuality.jpg 288w", "/static/7f4b1a82e885bd6ab855e798943816bc/473e3/punctuality.jpg 576w", "/static/7f4b1a82e885bd6ab855e798943816bc/8c352/punctuality.jpg 792w"],
                "sizes": "(max-width: 792px) 100vw, 792px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy",
                "decoding": "async"
              }}></img>{`
    `}</span>
          </ImageGalleryImage>
        </ImageGallery>
      </Column>
    </Row>
    <h3>{`The Catalyst Collection`}</h3>
    <p>{`For this upcoming collection of my science fiction and fantasy stories, each piece will appear as a separate, inexpensive short.`}</p>
    <p>{`I always love `}<a parentName="p" {...{
        "href": "/art-director/"
      }}>{`working with my designer`}</a>{`, but for this series, he really outdid himself. So gorgeous.`}</p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAECBAMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQID/9oADAMBAAIQAxAAAAHz3loWQULsrKzgOf8A/8QAGxAAAQUBAQAAAAAAAAAAAAAAAgABAxESEDH/2gAIAQEAAQUCwCzGjEbTjlXyR+C4ZsKf3//EABcRAQEBAQAAAAAAAAAAAAAAAAEQEQL/2gAIAQMBAT8ByHWCT//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/AaQ//8QAHBAAAwABBQAAAAAAAAAAAAAAAAEhMRARICJB/9oACAEBAAY/Al28Mk4rSqi3RMH/xAAdEAACAwEAAwEAAAAAAAAAAAABIQARMUEQUXGB/9oACAEBAAE/IaQinObUZnvQmoA6x9ga7C0PsXP1LlijnijBn2AbYjahgnjif//aAAwDAQACAAMAAAAQSMw//8QAGBEBAAMBAAAAAAAAAAAAAAAAAQAQEWH/2gAIAQMBAT8QGmld0mz/xAAYEQEAAwEAAAAAAAAAAAAAAAABABARIf/aAAgBAgEBPxBA5ORC7X//xAAgEAEAAgIDAAIDAAAAAAAAAAABABEhMUFRcWGBobHx/9oACAEBAAE/EKtQklqqkNdzlDV6uwBwzYr/ACKSoUvllD8VFxeq3LUdOPzAVkHk7dQgAMdfqIXzBJdljVWVz7AJCI1duc78PqNJUcOif//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/1aed2d6d07ed362b6568b3bb5a8933f5/2e753/catalyst-blackout.jpg",
            "srcSet": ["/static/1aed2d6d07ed362b6568b3bb5a8933f5/69549/catalyst-blackout.jpg 288w", "/static/1aed2d6d07ed362b6568b3bb5a8933f5/473e3/catalyst-blackout.jpg 576w", "/static/1aed2d6d07ed362b6568b3bb5a8933f5/2e753/catalyst-blackout.jpg 1152w", "/static/1aed2d6d07ed362b6568b3bb5a8933f5/490e5/catalyst-blackout.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIBAwQF/8QAFwEBAQEBAAAAAAAAAAAAAAAAAwEAAv/aAAwDAQACEAMQAAAByRct5rHNISnti/PNob//xAAbEAADAQEAAwAAAAAAAAAAAAABAgMAEhMhIv/aAAgBAQABBQISXGa8iKncDkIMZ/Rt6k5EvNgVIiizmZTJ/8QAGxEAAgIDAQAAAAAAAAAAAAAAAAECEQMTISL/2gAIAQMBAT8BssUYN+Vw04T/xAAZEQEAAgMAAAAAAAAAAAAAAAAAAQIDERT/2gAIAQIBAT8BaZLzWHS//8QAHRAAAgEFAQEAAAAAAAAAAAAAABEBAiEyQVGR8P/aAAgBAQAGPwK7phjidM2QfdJRiduYkNsin04f/8QAHhABAAMAAgIDAAAAAAAAAAAAAQARITFBYZHB0fH/2gAIAQEAAT8hv1uTdhrhRooxlg1yTl+oGCF23Z6g3Q66i5MC5NXzjLE+fGS/7h8VfqIwtfdjhB8Bn//aAAwDAQACAAMAAAAQmPnO/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERUf/aAAgBAwEBPxCCSDZoWTP/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAECAQE/EMbUAV7av//EACIQAQACAQMDBQAAAAAAAAAAAAEAETEhQXFRkcGBoeHw8f/aAAgBAQABPxBl6wUCALNvXhm1h4AMY1Md5Z7aSsApsjaNrFXZYny9phSXkBLk6V2h3dRBoVxGQaiJf5jOmALVQo+/iJ3LwaqyjPMPsK1kTxtDaj0RP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/05bf7553c307d6f034f34edfc13b943f/f6133/catalyst-commute-killer.jpg",
            "srcSet": ["/static/05bf7553c307d6f034f34edfc13b943f/69549/catalyst-commute-killer.jpg 288w", "/static/05bf7553c307d6f034f34edfc13b943f/473e3/catalyst-commute-killer.jpg 576w", "/static/05bf7553c307d6f034f34edfc13b943f/f6133/catalyst-commute-killer.jpg 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBAgQF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAD/9oADAMBAAIQAxAAAAHm6EaTfCWEYplqgSGn/8QAHBAAAgICAwAAAAAAAAAAAAAAAQIAAxEhEBIy/9oACAEBAAEFAlEK14xFliKvB8poxWTqGrAY7//EABgRAAMBAQAAAAAAAAAAAAAAAAABAhMD/9oACAEDAQE/AcTEronSo3P/xAAXEQEBAQEAAAAAAAAAAAAAAAAAERIB/9oACAECAQE/Ad8bRH//xAAdEAABBAIDAAAAAAAAAAAAAAAAARARIQIxEnGB/9oACAEBAAY/ArFjLp04q0PexJ9K0f/EAB0QAQACAgIDAAAAAAAAAAAAAAEAESFBMYFRkbH/2gAIAQEAAT8hJxSqYbIJenUcoLN+pyEsziNDvuK0Ny1v2PMEAuXMoBb4QVuGk//aAAwDAQACAAMAAAAQi9QC/8QAGBEBAQEBAQAAAAAAAAAAAAAAAQARQVH/2gAIAQMBAT8QxoLKk5yz5f/EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAgEBPxCMQASzf//EAB4QAQADAAIDAQEAAAAAAAAAAAEAESExUUFxgWGh/9oACAEBAAE/EHlAULo2s1Is0qgFaVrOHf5LldfCWPBc3D9l2XmLNPruNAGemxFG+T4/DqDRsDTVxilV97GqrrHFWV59wFUBErtt3n1ENscdE//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/c59bf5cd70701425113ab71dca27d1b6/f6133/catalyst-cram.jpg",
            "srcSet": ["/static/c59bf5cd70701425113ab71dca27d1b6/69549/catalyst-cram.jpg 288w", "/static/c59bf5cd70701425113ab71dca27d1b6/473e3/catalyst-cram.jpg 576w", "/static/c59bf5cd70701425113ab71dca27d1b6/f6133/catalyst-cram.jpg 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgP/xAAWAQEBAQAAAAAAAAAAAAAAAAACAwH/2gAMAwEAAhADEAAAAZXVRsNMwMUWVWJ7NNFR/8QAHRAAAgEFAQEAAAAAAAAAAAAAAQIDAAQREiIhMv/aAAgBAQABBQJApXVKb6jGXlTirZfRsyMhzFMqg3Iw0nX/xAAaEQACAgMAAAAAAAAAAAAAAAABEQACEBMh/9oACAEDAQE/ARVh42WHIzP/xAAZEQADAAMAAAAAAAAAAAAAAAAAARECAxD/2gAIAQIBAT8BeUc49abpD//EAB0QAAICAgMBAAAAAAAAAAAAAAABAhEhIhATMWH/2gAIAQEABj8Cy8i2HQi+PHZPsizWLo+iswf/xAAdEAACAgIDAQAAAAAAAAAAAAABEQAhMUEQYcFR/9oACAEBAAE/IcUU9lbAL6qCA4xqEAEIwBI8Z/mgCAw6rUcodoBsG+YaJz9UYRw1P//aAAwDAQACAAMAAAAQIAq8/8QAGBEBAAMBAAAAAAAAAAAAAAAAAQAQEVH/2gAIAQMBAT8Q3eKCACKu5P/EABgRAQADAQAAAAAAAAAAAAAAAAEAEBFR/9oACAECAQE/EBDqt8YAMn//xAAeEAEAAgIDAQEBAAAAAAAAAAABESEAMUFRYXEQ0f/aAAgBAQABPxCGnMQq3hrqcJZBgnBfMeGFAC2IsjzAzlW64wiIRIm/fn5tmi3uH9y8qAqq69xfU4UuH10kFRJHP3AgWEmmfd5FVG06M//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/b7f9ba97977d9b531477cc7f45c970a4/f6133/catalyst-faithful.jpg",
            "srcSet": ["/static/b7f9ba97977d9b531477cc7f45c970a4/69549/catalyst-faithful.jpg 288w", "/static/b7f9ba97977d9b531477cc7f45c970a4/473e3/catalyst-faithful.jpg 576w", "/static/b7f9ba97977d9b531477cc7f45c970a4/f6133/catalyst-faithful.jpg 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFAgT/xAAXAQADAQAAAAAAAAAAAAAAAAABAgQF/9oADAMBAAIQAxAAAAFLnalulncB84lsozqJFEf/xAAcEAACAwADAQAAAAAAAAAAAAABAgADERASEyH/2gAIAQEAAQUCRPnmIy4VTODWZ6oQluw31RSnXsmHN//EABgRAAMBAQAAAAAAAAAAAAAAAAABEhET/9oACAEDAQE/AbKKenRn/8QAGREAAgMBAAAAAAAAAAAAAAAAABEBAhIT/9oACAECAQE/AWaMQkcan//EAB4QAAICAgIDAAAAAAAAAAAAAAAhATECEBESIjKB/9oACAEBAAY/AnRT03BOllB58YnsOyO30VH/xAAdEAEAAgMAAwEAAAAAAAAAAAABABEhMVFBYXGB/9oACAEBAAE/ISun6JgBfcWljjg1crbuszym4Wl7jEvhHvcA1l8JRVc9zFhUNI7fyn//2gAMAwEAAgADAAAAEGwP8//EABkRAQEBAAMAAAAAAAAAAAAAAAERABAxof/aAAgBAwEBPxBVZgzvKhvvH//EABgRAQEAAwAAAAAAAAAAAAAAAAEAUWGR/9oACAECAQE/EDOVAoBy3N//xAAeEAEBAAICAwEBAAAAAAAAAAABEQAhMUFRgbFx8P/aAAgBAQABPxCw89BhI0SIT+kxYIPOvGOIEHMHTltbs1VOsSiaTlfWLdG0s+4x18KD6cR+yiYc9qu0lJ3+5V0Apa7kj4mOcROngz//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/831066122a0a7f7bb0178cf768775675/2e753/catalyst-maze-wizard-kitten.jpg",
            "srcSet": ["/static/831066122a0a7f7bb0178cf768775675/69549/catalyst-maze-wizard-kitten.jpg 288w", "/static/831066122a0a7f7bb0178cf768775675/473e3/catalyst-maze-wizard-kitten.jpg 576w", "/static/831066122a0a7f7bb0178cf768775675/2e753/catalyst-maze-wizard-kitten.jpg 1152w", "/static/831066122a0a7f7bb0178cf768775675/490e5/catalyst-maze-wizard-kitten.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgUD/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAEDAv/aAAwDAQACEAMQAAABzWIsWzh4W6MI9XKRID//xAAcEAACAgIDAAAAAAAAAAAAAAABAgASAyEREzH/2gAIAQEAAQUCRVq2NBCN+Q2lRMbtLQ5DEdAvYnBbf//EABgRAAMBAQAAAAAAAAAAAAAAAAABExEC/9oACAEDAQE/AXxjwkyjKM//xAAYEQEAAwEAAAAAAAAAAAAAAAAAARESAv/aAAgBAgEBPwG2oZ5VD//EACAQAAEDAwUBAAAAAAAAAAAAAAABESEQMXESIjJBUYH/2gAIAQEABj8CV+R3S0m7TPlGWRcl2whKSI/0VrH/xAAcEAACAwEBAQEAAAAAAAAAAAABEQAhMWFBUYH/2gAIAQEAAT8hQj4HFBRIoMf5Lqx1Eb2wI/JCmqnKKNEIHXFxiy4AYJA19iVGfj2fK+J//9oADAMBAAIAAwAAABAM6Iz/xAAZEQACAwEAAAAAAAAAAAAAAAABQQAQETH/2gAIAQMBAT8QxCdQC+TVmf/EABgRAQADAQAAAAAAAAAAAAAAAAEAEGER/9oACAECAQE/EAJ0m9Gc/8QAIRABAQACAgIBBQAAAAAAAAAAAREAITFxQVGBYZHB4fD/2gAIAQEAAT8Qe+ArIjs75/OQ+pYgyjevS4S55vh4xJEWh8rrf3xtFKk0tJz1n8S4r6VKxPkx1Qx8nEP3im+mGTtbj2NFHEpPPeQLydlr2b6y7bDR6M//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/93297ca674a948ced0bc47b3697885c1/f6133/catalyst-memory-loss.jpg",
            "srcSet": ["/static/93297ca674a948ced0bc47b3697885c1/69549/catalyst-memory-loss.jpg 288w", "/static/93297ca674a948ced0bc47b3697885c1/473e3/catalyst-memory-loss.jpg 576w", "/static/93297ca674a948ced0bc47b3697885c1/f6133/catalyst-memory-loss.jpg 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBBAUC/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAAB5ivoXOMMM9FtXI5KoL//xAAdEAACAQUBAQAAAAAAAAAAAAABAgADERITFAQx/9oACAEBAAEFAuZJziMk8rANVqLjtaByIKk13g1WxSx+/wD/xAAZEQEAAgMAAAAAAAAAAAAAAAAAAhIBEVH/2gAIAQMBAT8BaitlaPH/xAAYEQEBAAMAAAAAAAAAAAAAAAAAEQIiUf/aAAgBAgEBPwGNkTLr/8QAHRAAAgMAAgMAAAAAAAAAAAAAACEBETECEBMiQf/aAAgBAQAGPwJPqK4zh9G7wRoy/JB7XZGiP//EABwQAQADAQEAAwAAAAAAAAAAAAEAESFRQWFx0f/aAAgBAQABPyEyGl95HaxKqvnfyPvXZ+44sedmQLCwMSxUcqZxQ5BeMx5A5LcayFvJWzbNpiBeLyf/2gAMAwEAAgADAAAAELjlw//EABsRAQACAgMAAAAAAAAAAAAAAAEAIRFRkaHh/9oACAEDAQE/EFM6hhtePYFZc3d2f//EABsRAQACAgMAAAAAAAAAAAAAAAEAESFhkeHw/9oACAECAQE/EBVUW+A56lHU9Cf/xAAgEAACAwACAgMBAAAAAAAAAAABEQAhMUFRYaGBscHh/9oACAEBAAE/EBamgSIALkNe4EC8aWTg8dBEyRZM5OlWQSnLkigAtqXMAbgHP2EGBYAVM1ASivmF0uCW/cbMBs79y4tLRQFf2DW68x16QgDDa3XE/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/f090c6d6121a8b2d2189053c937fc336/2e753/catalyst-mortals.jpg",
            "srcSet": ["/static/f090c6d6121a8b2d2189053c937fc336/69549/catalyst-mortals.jpg 288w", "/static/f090c6d6121a8b2d2189053c937fc336/473e3/catalyst-mortals.jpg 576w", "/static/f090c6d6121a8b2d2189053c937fc336/2e753/catalyst-mortals.jpg 1152w", "/static/f090c6d6121a8b2d2189053c937fc336/490e5/catalyst-mortals.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAX/xAAXAQEBAQEAAAAAAAAAAAAAAAADAgAB/9oADAMBAAIQAxAAAAHn0V0NDOd20spNICo//8QAHBAAAgIDAQEAAAAAAAAAAAAAAQIAEhETIgMh/9oACAEBAAEFAqigVYU85syNn1ujqzG6bXEWq0EKPn//xAAZEQADAAMAAAAAAAAAAAAAAAAAARECAxD/2gAIAQMBAT8BvE9cLgf/xAAYEQACAwAAAAAAAAAAAAAAAAAAEBEhIv/aAAgBAgEBPwFaks//xAAeEAABBAEFAAAAAAAAAAAAAAAAAREhMRICEDJBUf/aAAgBAQAGPwKLLOQiNSMO174xHhZL5Gl+hWWD/8QAHhABAAICAwADAAAAAAAAAAAAAQARIVFBYZFx8PH/2gAIAQEAAT8hy1fDyLLaOvJe++YNQaDFir/VxtgVRULIDUMbdzvWZBJcwvVrFKTPrSf/2gAMAwEAAgADAAAAEIsQAP/EABcRAQEBAQAAAAAAAAAAAAAAAAARAWH/2gAIAQMBAT8QhcVK5P/EABgRAAIDAAAAAAAAAAAAAAAAAAARARCB/9oACAECAQE/EGMnCn//xAAeEAEAAgIDAQEBAAAAAAAAAAABABEhMUFRgXGRsf/aAAgBAQABPxBN80xUeMtffyF/CMdtZ2wgcFuxQrIOOgYB85lClVcYRcsoaYekNoAb3qANUi+/sXMwCqgm12vMCal0BiO1uCtoDXF/YFQFBbUun+S1Wjfx7P/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/b18438d02c2e39dc9ac3f3b08c8c4745/2e753/catalyst-thorn-necklace.jpg",
            "srcSet": ["/static/b18438d02c2e39dc9ac3f3b08c8c4745/69549/catalyst-thorn-necklace.jpg 288w", "/static/b18438d02c2e39dc9ac3f3b08c8c4745/473e3/catalyst-thorn-necklace.jpg 576w", "/static/b18438d02c2e39dc9ac3f3b08c8c4745/2e753/catalyst-thorn-necklace.jpg 1152w", "/static/b18438d02c2e39dc9ac3f3b08c8c4745/490e5/catalyst-thorn-necklace.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIDBAUB/8QAFgEBAQEAAAAAAAAAAAAAAAAAAwIB/9oADAMBAAIQAxAAAAGBJUlKAgo3+rYyc40CF//EABoQAAMBAQEBAAAAAAAAAAAAAAABAgMSESH/2gAIAQEAAQUCzxmpnJUapTWKNpXTMrSPYRS+xxyuBqT/xAAaEQACAgMAAAAAAAAAAAAAAAAAAwECEBES/9oACAEDAQE/AWL5wxs3sRo//8QAGREAAgMBAAAAAAAAAAAAAAAAARIAAhAR/9oACAECAQE/AaWY8wBRHn//xAAgEAABAwMFAQAAAAAAAAAAAAABABARITFRAhJBYYGR/9oACAEBAAY/AuVq6Koxg2xlqz4LI7Z+NW6Et//EABwQAAIDAAMBAAAAAAAAAAAAAAERACExQVFh0f/aAAgBAQABPyFtKUF6VDVDiFAABxBHmNuyxAEVAdmVWR1ARD655DHT4jxZiKjdZP/aAAwDAQACAAMAAAAQI8uw/8QAGREBAAIDAAAAAAAAAAAAAAAAAQARECGR/9oACAEDAQE/ENPF05Ay2f/EABcRAQEBAQAAAAAAAAAAAAAAAAEAETH/2gAIAQIBAT8QZEcsghn/xAAeEAEBAAMBAAIDAAAAAAAAAAABEQAhMWFBcZHB4f/aAAgBAQABPxCmVsCNCzZra4Ru1mNB8bK33GFA2161P1gQu3AeeZ3mAds6a5vyM9uVDSxUejf3irUqdhX1uMkEEH5YUEWynOP7hIVVR38YB2Fa+s//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/f63464956f2fa8421c26f17cd745111c/f6133/catalyst-time-out.jpg",
            "srcSet": ["/static/f63464956f2fa8421c26f17cd745111c/69549/catalyst-time-out.jpg 288w", "/static/f63464956f2fa8421c26f17cd745111c/473e3/catalyst-time-out.jpg 576w", "/static/f63464956f2fa8421c26f17cd745111c/f6133/catalyst-time-out.jpg 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMCBAUB/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDBP/aAAwDAQACEAMQAAABzZ2ptbLLoXbxLBkeUBaf/8QAGRAAAgMBAAAAAAAAAAAAAAAAAQIDERIA/9oACAEBAAEFAlQcYxt0pkFCuZbYtmQya5SgVXjrcdMwv//EABkRAAIDAQAAAAAAAAAAAAAAAAATAQIRA//aAAgBAwEBPwFQgnpbdHWP/8QAGhEBAAEFAAAAAAAAAAAAAAAAAQACEBETUf/aAAgBAgEBPwGxSBiajs//xAAbEAADAQADAQAAAAAAAAAAAAAAASERECIxYf/aAAgBAQAGPwKnwnLNTgsz07Ol9FpD/8QAHRABAAMAAwADAAAAAAAAAAAAAQARITFRYUGxwf/aAAgBAQABPyFx0zfuBAN969hKcImU0rERXLAoC/wmJVi8hg9UoQtGV6L+di28J//aAAwDAQACAAMAAAAQpN+z/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARIf/aAAgBAwEBPxBw5GjZ56gy/8QAGREBAAIDAAAAAAAAAAAAAAAAAAFhESEx/9oACAECAQE/EMQ0kPVrD//EACAQAQACAgEEAwAAAAAAAAAAAAERIQAxQVFhcaGB4fD/2gAIAQEAAT8QPCSMgFLprxiHIeOmnTpNYoKgL785KYSyomv0GEmQe5u/PfJjrHWNLWEuiV94dgdNpYfjAepnReWPWXdhfEV95sACISluOfGD5DaM/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/5bde358e9eb628cde64bfe79c2faf121/2e753/catalyst-toaster-electric.jpg",
            "srcSet": ["/static/5bde358e9eb628cde64bfe79c2faf121/69549/catalyst-toaster-electric.jpg 288w", "/static/5bde358e9eb628cde64bfe79c2faf121/473e3/catalyst-toaster-electric.jpg 576w", "/static/5bde358e9eb628cde64bfe79c2faf121/2e753/catalyst-toaster-electric.jpg 1152w", "/static/5bde358e9eb628cde64bfe79c2faf121/490e5/catalyst-toaster-electric.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Catalyst" title="Catalyst" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgH/xAAYAQADAQEAAAAAAAAAAAAAAAAAAQMCBP/aAAwDAQACEAMQAAABksM7XRGKgzu5jhG0Tjcv/8QAGxAAAgIDAQAAAAAAAAAAAAAAAQIAAxESIRP/2gAIAQEAAQUCrXMauEdVQo5DRtDYWiNsVJCqU1qsRB7T/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAECEyH/2gAIAQMBAT8ByZmO2Oun/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAEREBL/2gAIAQIBAT8BuRHKP//EAB8QAAICAgEFAAAAAAAAAAAAAAARASECECIxMkFhgf/aAAgBAQAGPwK+hK17F4HjA6Z24/JKo5Nka//EAB0QAQACAQUBAAAAAAAAAAAAAAEAESExQVFhcZH/2gAIAQEAAT8hspoHEEw2GmIlrMypXW75ERdDp7EdymUPo7h1WHKYhAoIqiyY8gc33Kmjjaf/2gAMAwEAAgADAAAAEMvB/wD/xAAYEQEBAQEBAAAAAAAAAAAAAAABABExQf/aAAgBAwEBPxCMetrEeTKb/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERQf/aAAgBAgEBPxCCiZgoH//EACEQAQEAAgICAQUAAAAAAAAAAAERACExYUFxkVGBodHh/9oACAEBAAE/EJLbFQW8/TpygWi3ZdhSesGEgxJMeOqnlGifOJkFvyP6xqpyM0vmdYYo6CCevTikQY7D3r88ZIAcAXOpYLDT+4gT06o1up9phWc2+mf/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Catalyst",
            "title": "Catalyst",
            "src": "/static/52fe007c7ca3dec5e31a805472b8225e/2e753/catalyst-uncle-jacob-spaceship.jpg",
            "srcSet": ["/static/52fe007c7ca3dec5e31a805472b8225e/69549/catalyst-uncle-jacob-spaceship.jpg 288w", "/static/52fe007c7ca3dec5e31a805472b8225e/473e3/catalyst-uncle-jacob-spaceship.jpg 576w", "/static/52fe007c7ca3dec5e31a805472b8225e/2e753/catalyst-uncle-jacob-spaceship.jpg 1152w", "/static/52fe007c7ca3dec5e31a805472b8225e/490e5/catalyst-uncle-jacob-spaceship.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <Caption mdxType="Caption">
      <em>(In development.)</em>
    </Caption>
    <h2>{`Kids’ Books`}</h2>
    {/* ' */}
    <p>{`My wife Beth and I are the lucky parents of six (yes, six) beautiful children. Our oldest is just starting college, and our youngest is just getting his teeth.`}</p>
    <p>{`I’ve read them a `}<em parentName="p">{`lot`}</em>{` of kids’ books over the years, and perhaps it was inevitable that I’d feel compelled to contribute to the pile.`}</p>
    <p>{`These are in development, but most are fully illustrated and nearly ready for publication. For sneak peeks at some illustrations, see my page on `}<a parentName="p" {...{
        "href": "/art-director/"
      }}>{`art direction`}</a>{`.`}</p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="How to Talk to a Rock" title="How to Talk to a Rock" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "615px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEz0lEQVQ4ywHEBDv7AEGekDaRnWLBbVi1ei6MqARc1Q5kygdh0Athzg9jyg5iygxhzAVd0wRd1A1iyw5lyg9lygpfzgZd1QpcxQBZuHZOqoMKYdAKZtEeccE9fakvdLMpcrUebL4IX9AMYc4YZsFQgZNPhJcXasMNaM4LY9Amf7A9mpk0iZkAV7Z5S6eHD2XLBWLSM3awb494f5l0dJJ5YoqGRX+kNHSuJWy3Q3mcnaJTSn+TC2jPCWHSOJScddVdSqGAAD6algZe0xJoxwtjzStxs1SEkpqjXX+Xb1SEj7exRYaabAdezk6CnbGsSzx2oBBnygxnzzCLqEuqjInjOwAXcMMNZ84Na9AEZNYHY9EncrgtdLA8eZ8hbbc4cqA6c6EAWeI/eaJTfYkZZ7wLZM4QassDXNkXc8VOpX0ADWjPDWvQFW7HRIKfXI2MDmnLLnu4aJaMG3LHCWXOJm2wdZN0MHKoAF/WCWLQE2jIEmfICmLQL4upJ32nAA9tzg5r0BBnx16GhHePdEyAk3iYe5ChaX+aahlrvhFoyICYdF+IhC9zrwdg0XiVdi12swBd2TWSoofhPAAObtAQbc4GZtUbbcOapGKRnV+QnmOLnm1ni31AfJwPZ8qGmm6Al3Aob7UmbLOUnVk4eK4FZtQNb9YcdbcADmrND2/QDnLUF2rFbIh6K2urP3WcSn6UDGPOGWi+F2nBD2LENXKhNnapD2HGUX+UPXelBWjWEXXTDGTJAA5lyw9szg9v0A9lygxfyh9rwYKdcFWNlVWPohpvwQtkzzp8qz98p5KiaARd1BVkwxJlxg5s0A901BFpxAAOZMsOZssRaMoCXtJXiJKzsUpvhm6imGKtmml4i4prinqBlmtlhoGWomYBW9USZMYMZcwPbc8PdNQQaMMADmTLD2fMDGXIG3Dcb5WTfZxvRW+Ue29rXFpse3l+yrc4H2XHQHip4MkraYx2Rn+0JHTTC2nMEHDTD2XCAA5ozBBtzglpzit+3E+LvZKoZ092gmhZT21lbYB+asW4PXSYf4edcKGjV2+KblqQviJx1AtozBFu0Q9jwQAObNAOd9oSbcwOZ8sUXblrjH0ndbdjalt9cElMdY00caZzi2+EmWtkjIkYY71ZhIQAYs8IbtAFbtMQYcAADmfLHjF5HgA1IQM6JQ9JCGPIBnDZE2zGI3G4BGTQA2DPAFzaGGW4H2m5AWPUKmDGu2KnzGWmWW3CCGPCABRDmDwLLH1bX5x3a1dWeRt10XSu412e4DSH3jOF1liZ3GGe2m2l5FyY3gBmzZlvrf+Em/J/muRwoiNlvgAOQ6KIaGjVyq7y4rKFm7IYcNGBsORxqOFbnd1Qmd6Ft+hfn+B8reJOktkMYsudiabe0KvEvKbuoKlHXrcAAEenhpCd8dyv07aYe6C/MoDXV5baVJTbYqHiSJjgRpPcXqDgP4vaUprgTITVwoak4c2g5tWv94qhVVKZAAU/egpTo2h9hWhkWxZluxlz1hpw0Bty0RpyzRlyyxd11B9+1xp50xx0zxlov19hqLyS37aP3WVXliI9agANVasCS6Q7WG86NycdU4MEW7QLYLsKZckGUaQGUqIMbM8JZ8IGTp4FTJ0CS5YRVZeYaPmIZecLV54DQ4UCGCs3e3CrTgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "How to Talk to a Rock",
            "title": "How to Talk to a Rock",
            "src": "/static/4ca98e266a96273026700f44995fcd21/83210/how-talk-rock.png",
            "srcSet": ["/static/4ca98e266a96273026700f44995fcd21/7fc1e/how-talk-rock.png 288w", "/static/4ca98e266a96273026700f44995fcd21/a5df1/how-talk-rock.png 576w", "/static/4ca98e266a96273026700f44995fcd21/83210/how-talk-rock.png 615w"],
            "sizes": "(max-width: 615px) 100vw, 615px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Julie and the Wishing Rock" title="Julie and the Wishing Rock" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "655px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEz0lEQVQ4ywHEBDv7AKSIqoNhlopmmZBqm5hwnZ11np1vnaBxnaN0nqRznqZ0nqd2n6l3n6t4n615n696oLB5n7F7oLR+obiDowD73NXQpbXChKDLjqTJf6HEbp3WmKjUjaXBV5jSgaLbm6jalafblqfemanhm6vemKjgoK7gnavgmqfinakA+/jt///y7M3O3p6s246qyVqa3Iem02+gy1yc022ezmWc5qWs6qmw356n3p+k7qyw9Lq/8L/B9cjH8sPDAPj07Pjy7O/U1eWyuuixuctioMNMl8BGl89noMFHmNNppcSUi6t/cayDbbWJepVqX9ylnvrNxvfVzPfUygDvyMTxxbn0xLb1w8DrrLzlm6nhksDpprnnpL3/26/4y7L71rDkrLPJd7/qtrPPr4jfupr/1rf3zLT2zrgA3s7F2anO2JbVzHXf1Ibd4KDZx2Hoz3Tj14jezW/h0nzf4J/X3JbbvEHz4KTY9MzQ7cXK4qrK6sXC7M7CAN/izM6c3LE89LlN8MNj7Mt26Mhq6sZi7Mtv6cJY78hr6tCB496n3st058Zm6LxP68dr4sBb5ebCvefLvAD55q3437DOc9zmtcz03sPltdLThuHYk93bmtrfpdLgqNDx2M//+LL55qnnsLXkoK/ScMPKWcjvrpbxvpsA86Zy+ch889Rz+eB4//eK9+KW9d6Y+fOS+vWN+/l/+Pab9u5t9tNC98tA//td/upi+8hf+LJg9qxi9LJrANp3VppEPpE1NbJGNNJ3P/rlevXue/bngPPliOrYit7Imd7Gj+DKj+TNkePOd+zdWPrkZv3bbPnWa/fbhwB1KTOXUCmwZymaOjq/VUfil1+2nGqAaWWUgHKRfHGijnqchXSrknitlXnAnXjhxm7yyl3vrnTqkV7ngWIApWop3acv5LVh68Gd9tu0yo15YDQ4b1FMSTM8NCMzOyo3PSw3RDA1XDYwqGtEx51cw35g7pyD4FU/1Uo6AIBBJbqBVdS5qqybjPfkxpeCg6ZwW6V4Y00tPU4wPkwvPEwvPVc0Pms8QWI2QVQvP1o8SJR6esaLj9u0twBWGiaSVE3y3LjOv6z24b/s1rrbo3RwSUxUMEBYNUFVNEFdN0NiOkVgOkRsQEi/YVzRZV14O0VaR1a5srAAVSEnezw7+92u4MSenHh60aaKtIFgWzZDZDtDXDdDXzlEYTpEZTxFYjtCeUJJ2V9d0VlbnFpWvGZMy19FAFImLmcoK556b8+wn963mMV0YJNIN1k3QWA4QmA5RFw0P184Q1s0QF02QmY9RWg5Q2dCS9NvUOxgQeVfQgBPKTNTIyhHKFR6U4+thXCzhm28p6qEc3t3XmdpSVKgj5R4X2ahj5Saio9mQkpWMkCFTk3nZEXbXj/eWToALyAvNicyTTFxg1+Lj21bh25lqaeqhH2BhHh/a1tjpaCifHF3jIOIjYWJUjpGRy08ZDI/z0tC5lI76pWHACojLzouPkAjc0EkbFlLSmpiZWVfZmtma3Juc2BZYFZOVnRvdWBYX2ZfZW5nbToqOCIXKVYoNns0QOri5AAmIi0sIUFAInNDJm8nIjEhHiwiHSsjHi0iHisjHiwjHiwlIC0nIS8lIC0kHy0oIjKKhY3Z3eDByc7p6uts5qngz9jdPQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Julie and the Wishing Rock",
            "title": "Julie and the Wishing Rock",
            "src": "/static/0a9702be9c34b8529a286b187a033248/7bf3a/julie-wishing-rock.png",
            "srcSet": ["/static/0a9702be9c34b8529a286b187a033248/7fc1e/julie-wishing-rock.png 288w", "/static/0a9702be9c34b8529a286b187a033248/a5df1/julie-wishing-rock.png 576w", "/static/0a9702be9c34b8529a286b187a033248/7bf3a/julie-wishing-rock.png 655w"],
            "sizes": "(max-width: 655px) 100vw, 655px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Rosa's Third Rhinoceros" title="Rosa's Third Rhinoceros" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "613px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAFNklEQVQ4yy2VW0zTBxTG/zHL9rQs2duSvU+zPeySzSwzMhkKixtbRIUhtAJBK45OW4ENUS4WKLTQQq8CKgoTAhsgylREylULtVzkMkopBUodguIlqEMpv43iw8n3dH7nO8n5coShdyIYfHMPA2/s4e7bEUyFHuaRLgPfsA4mjKyOG9bLua4+pwGmzMzb8ulvOgme04h/kPHWBjHvvRuHMPbhfubkyczLjvGkLBNmzLBQ4ofhel3TJpg0gscMTgMrfxdRq4oj9MuP8HZlkRSXyqcbJXy26RDCQnoqLJWyNFXOqvcsOPW8urPuzjdswDeiZ7lTw0pfMc/+yge3FkNrG4VZaagT93LtSjErozpwmbhVk4fgjT0K90qYvqTD06WFIR3e2HjmpBI8kbHcO3iA2ahIFjVS3N9H8Kz0MLVXr5LZOUJAyRiDw5dh1sC/YzqY1CM8yE1DXX+YjupMUk0J/F51lMXQWFyBoTz4JYq56HDmDoi5Hy1iITyCh8kiuHWMf2bqaLU3c79bwfO7+dxr1fKw14jAhJmP00P4Mf47doYFkqgIZzkxHk9cOGNiERPSaFy7IhiWhDOUG8/FXyVkSKUwqoLpIhqNGVSas5m2neOx1YzATAntbel88PlGtm76gJH2TLiZwz1ZNMVpEpTS/RTI4vhpp4h9O6ORRUaTHrsPR1MqFredruoaatrvYO2x4BvRIfjGDTBdgud2Lk9sKtYGrIwYwJbNzbI0DPJDiILEiAMjiQnah3y3iKQwETOdOXTbrDRFxlF7toa6WxZ8U6fXVjau39akiYl+FRfrE3BZU3no1HOtMgVjXgxlKjF5x8NRntiDNGE3p46H0dV6lM4rJ1j4y0TfFR3W1vN+huCHuUw8Ginih5wdiPID2KsMJOBkAAEZW5BovyZcFYjiTAiS4u3sUm5BZvyGvTlbUZ7fhae7hMGbBTBthnE9wupr4NLfeqLUwURmf4FEtYXY/K9IKAggyxRMUlEQGcZgftEEEV8YQFh+ACn67WjPh/K838B819qGBlYcBoTVtUQ4dODU4ehM4a4liSVHIS+HMsGpZmU8D9xqXowpwZXPeJOMCvV3POg9CuMqcBt4Mqjm2ZAWvKUIazYfddey1F8FjhJG285haOtk2vkny/Z8vK2FeBtUrFjzeH69kLvx2Vgq6uk/c5pFSyF4S7BfSkOTFsn18iMIr4aNTNp7+Mc9SXN5DqXZicgPHuBGvZqF9lwuZh+n+uSvTNcdZ6DjMnUtd6jo6MFY38Ho7d9xtqTTUiFHuj8E8e5tCIyZmLR10dNzG2WKDMWxOJIl8Qw3KXC2KUk5kkh1WR7tDVra7L1c6hqg+no75Ve76bjVgqUqhYSo7Uj3f0uiOARh3KZgeaiWvsZLNJmTqCiUojkhZd6u5emIgazUJM5oFDReyGXedYX2/gGau600tzYxOViPQh5GbHgg0pgQfhYFI1xolIOnlBd9Jr+uOot54axltKCWvpOVTFkGmBtx0a9pYLauDav8ApMNvTBXBRNarp07QoIomJg92zgQGYQgL4sFTxm4jSyP6VlxaPHNNDJccIO+5Iu4yy08tjkZ+K0Kh6mFvuRK7jcPwnwDvjGt38SE5RRlyhiyZGEIGw5tZlPqDno7s2D2DMyW8mLYzI3KYqx1xbSU5dFRpaGjpojuag0df+hpq9Tw0mGGCQP+6LrN/r5FuxpBkGxGiPmE949tI94YhaJSgrdfzdO+IhbtGh4NFLPQq+GhTcPTgSK/zvdo8I3r11+Ec/0t+MH/R+8/pIeU6Kz1UvwAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Rosa's Third Rhinoceros",
            "title": "Rosa's Third Rhinoceros",
            "src": "/static/1975426b5588249e0a56011d75884943/8f646/rosas-third-rhino-yellow.png",
            "srcSet": ["/static/1975426b5588249e0a56011d75884943/7fc1e/rosas-third-rhino-yellow.png 288w", "/static/1975426b5588249e0a56011d75884943/a5df1/rosas-third-rhino-yellow.png 576w", "/static/1975426b5588249e0a56011d75884943/8f646/rosas-third-rhino-yellow.png 613w"],
            "sizes": "(max-width: 613px) 100vw, 613px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="The Dog Who Had an Apple for a Nose" title="The Dog Who Had an Apple for a Nose" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAEDBAX/xAAXAQEBAQEAAAAAAAAAAAAAAAACAQAD/9oADAMBAAIQAxAAAAHAq0mZhTHVA6Buf//EABwQAAICAwEBAAAAAAAAAAAAAAIRAQMAEiEEE//aAAgBAQABBQLmawnGNwAbQVZP6EvLys643//EABsRAAIBBQAAAAAAAAAAAAAAAAABAgMQETEy/9oACAEDAQE/AUlm1Pols//EABkRAAIDAQAAAAAAAAAAAAAAAAACAxExIf/aAAgBAgEBPwG60tSXii4f/8QAHBABAAEEAwAAAAAAAAAAAAAAAAERITEyQWGR/9oACAEBAAY/AlpYYcetVFe03l//xAAcEAACAgMBAQAAAAAAAAAAAAABEQAxIUFhgZH/2gAIAQEAAT8hSbVRIeuIRHb2E04diMqupcogPsoDyVtmECns/9oADAMBAAIAAwAAABCk/wAD/8QAGREBAQEAAwAAAAAAAAAAAAAAAQARITFx/9oACAEDAQE/EEIzfJEeo6NuLC//xAAZEQEAAwEBAAAAAAAAAAAAAAABABEhUaH/2gAIAQIBAT8QQbgQu/Y2wybK8n//xAAeEAEBAAICAgMAAAAAAAAAAAABEQAhQWExUYGhsf/aAAgBAQABPxBArDBJwPPxioUKbVMbCu4j6ceBqPhxcAbmNBvp0xy2TbK7d3nAhABCeQy6u47BiEp3HI0AoB7g/q5//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The Dog Who Had an Apple for a Nose",
            "title": "The Dog Who Had an Apple for a Nose",
            "src": "/static/8c3b85a18b6e57c63b1175407151503f/2e753/dog-apple-nose.jpg",
            "srcSet": ["/static/8c3b85a18b6e57c63b1175407151503f/69549/dog-apple-nose.jpg 288w", "/static/8c3b85a18b6e57c63b1175407151503f/473e3/dog-apple-nose.jpg 576w", "/static/8c3b85a18b6e57c63b1175407151503f/2e753/dog-apple-nose.jpg 1152w", "/static/8c3b85a18b6e57c63b1175407151503f/74f4b/dog-apple-nose.jpg 1728w", "/static/8c3b85a18b6e57c63b1175407151503f/de5bb/dog-apple-nose.jpg 2304w", "/static/8c3b85a18b6e57c63b1175407151503f/2e69d/dog-apple-nose.jpg 2550w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="The Shopping Mall Dragon" title="The Shopping Mall Dragon" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIEBQP/xAAXAQEBAQEAAAAAAAAAAAAAAAADAQIE/9oADAMBAAIQAxAAAAG9nzlLdVCFkSA6OATP/8QAHRAAAgIBBQAAAAAAAAAAAAAAAQIAAwQRExQiMv/aAAgBAQABBQI9gbSJUC6KdYFm+KYmQ9ach7Hs9//EABkRAQACAwAAAAAAAAAAAAAAAAEAAgMQQf/aAAgBAwEBPwFxVY1Dm//EABcRAQEBAQAAAAAAAAAAAAAAAAEAEQL/2gAIAQIBAT8BO0tWyL//xAAdEAACAgIDAQAAAAAAAAAAAAAAAQISESExUZGh/9oACAEBAAY/AnXRqSZnKZmu+7HDjnwo5/CseCNuxn//xAAcEAEAAgMBAQEAAAAAAAAAAAABABEhMVFhcZH/2gAIAQEAAT8hwnlbEU9SbxnILp8ChtAjC0y/Z045FkAteoCEIF1NjuZ//9oADAMBAAIAAwAAABBMH4D/xAAZEQEBAQADAAAAAAAAAAAAAAABABEhMUH/2gAIAQMBAT8Q8BJDCbwT3f/EABcRAQEBAQAAAAAAAAAAAAAAAAEAETH/2gAIAQIBAT8Q6LsE3ZGrcF//xAAeEAEAAwACAgMAAAAAAAAAAAABABEhMUFRYZHB8f/aAAgBAQABPxDAXaOfHcOOGHk8QX9kMoSx64Y5zdzotcRtfMxspGUrapdviD0V9697tdyv+LWrYU/SeR+xXWC1g9z/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The Shopping Mall Dragon",
            "title": "The Shopping Mall Dragon",
            "src": "/static/189fc45b06ddcc5f0618905fbc18a960/2e753/shopping-mall-dragon.jpg",
            "srcSet": ["/static/189fc45b06ddcc5f0618905fbc18a960/69549/shopping-mall-dragon.jpg 288w", "/static/189fc45b06ddcc5f0618905fbc18a960/473e3/shopping-mall-dragon.jpg 576w", "/static/189fc45b06ddcc5f0618905fbc18a960/2e753/shopping-mall-dragon.jpg 1152w", "/static/189fc45b06ddcc5f0618905fbc18a960/74f4b/shopping-mall-dragon.jpg 1728w", "/static/189fc45b06ddcc5f0618905fbc18a960/de5bb/shopping-mall-dragon.jpg 2304w", "/static/189fc45b06ddcc5f0618905fbc18a960/2fbf7/shopping-mall-dragon.jpg 2623w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="The Trapped Mathbook" title="The Trapped Mathbook" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEx0lEQVQ4yxXCaUxTdwAA8H/b95hA6QGUlt6vrVLK2RZo+17f0QsoLa3DVmqLLYcUBLpWCOVSkUMsoqAI04kTj8iEuUXmkmVxGqObyaImy5YtWxb3YVviB3WHMy5btnTZLz8gh8wIbJZDuBDgYkAgMInANinNLqHViWi1MoZVyqAkNEoGk1IGqcggkAwKybDIYVwBEUAICFyOLw0ajseNJ/YZa9WWyXbz+XFsppO4eMh0KIKd7kfn38AOBonGMioP1MrodWLgkNJtCEwCGYMsyqJ26IndBNnpIFGpzV1u78BtfV5itA2LeImBuHkwgs9N6f0uwkZibje23YPVk0bFaxaAZFBiYA1GTbFZ454xY3eyak8SbYkRvTPGcAJLrqDJt3QTV7XhfdjUZvXgyZrBNw3nvilPpLSFwArkECljkLE5w6mH2tRH+sMb+tGVmo4k1TFE9kxh0XGiZ6Q00qUL9xidbrxpp9HjNVlteG0DqmISQE63ILBVp6Kqiq0VcrtG6FSyPWJaAMkMI1kR2ZaQqv4wHxkSgwYJ3SMCbiFoFIFGIXDJGHaAZOqQTL2EYRDTTRI6WiwKKXLaZHA4l9bOAW08KHrl7p3Ewjob+AQ0FxfUi+hOEeyRwG4EqgUqPu//Ap6Sz1MVsKurfEX8mAQK99ZG1pOhG0c7n3219vTu3Af7fdcG/YteJ17oIiBKC9klkAOIcvNEubmSvDwVX6DkcQ1aHxfuGWhoTt8P/Hvb/8Vy79rC8J0zQ08utac/b0l/Evgy7v52eXSpobkAEIDNzGFlM/NYnG2CQhWPW1LmD4dS378bT3+697vNfo94rCFn1pI1E62Ivbjhf/lx6Om0+4eHF3s9ewoBBTjMHHY2M5/NKSosRPJyXdbGcwfiv97qT/90/Pmj1Eri2OXhCyfaVx7fnP/jkvvVKeejYX/5wm0xbEcYNsBmZrOys/PZLLWQz83KPdJD/XJr4PHNAw9GW5cdiWTFzAnbxNXY7Ks7yVfx0ifbdc/GfFOLZxQcl5xmBtysfE4WN59ZUCyQ6YT8hb2O9IMj905eTLHbVitbJwTdb8ub1l8PvtxsSq/pn7eV/t6KxQwuHrArYAps3YLKmWp5ZmVxpuXHmO6fSdPf4+VLla1f77Dej3pPF4fTkyV/vV94dmO+f/3Rg2t709GysRpHPrAqYBIYhGqDWFUlUDVVlmyONPw8qvstqT+j7XwRV192RD5rrEuPFP35odeSurdl59XE2SvpVPVkfSAP4MoMHFRwdBVcvSZbFzKWXp92dXsiu1tOLY8cwqrG1hfmPQrKxESTbnx2da584MLA4c7Bpuaws1sEUAQmACrSYGKNga/eZSje2N/QRASZnJhWHRUphkljQsa28yCCA8zeGnOLk7QVUUpOY7Xco+HYpAwMaFhaDUtbwqoqYRl1PKIshyoA1a3u6Huri2ePzx07ON3l63OUBa5vrPV3HJwYmD6/tPjO6ulOX68A1AAp3Sihm6R0XEbHpTSzEraIAWnRBPs7DvS1DA91j/eFhvyWrnh4uL99tC843LF9X7Jr3KkPiYARyCGDDDLIIVQB4SqYVEKEjGHemlmLIkFUsQtVBDBlM7EtoBN4UGQnsTVokPlJdUsJp05KN/0H2+xuZSQqgQMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The Trapped Mathbook",
            "title": "The Trapped Mathbook",
            "src": "/static/e6974b17bf3e3eb932864d91b8d2fe18/3cbba/trapped-mathbook.png",
            "srcSet": ["/static/e6974b17bf3e3eb932864d91b8d2fe18/7fc1e/trapped-mathbook.png 288w", "/static/e6974b17bf3e3eb932864d91b8d2fe18/a5df1/trapped-mathbook.png 576w", "/static/e6974b17bf3e3eb932864d91b8d2fe18/3cbba/trapped-mathbook.png 1152w", "/static/e6974b17bf3e3eb932864d91b8d2fe18/0b124/trapped-mathbook.png 1728w", "/static/e6974b17bf3e3eb932864d91b8d2fe18/4ea69/trapped-mathbook.png 2304w", "/static/e6974b17bf3e3eb932864d91b8d2fe18/201e7/trapped-mathbook.png 2551w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="The Playground Queen" title="The Playground Queen" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "153.81944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The Playground Queen",
            "title": "The Playground Queen",
            "src": "/static/7113911b86362e6f77f201bc12eebd4d/3cbba/playground-queen.png",
            "srcSet": ["/static/7113911b86362e6f77f201bc12eebd4d/7fc1e/playground-queen.png 288w", "/static/7113911b86362e6f77f201bc12eebd4d/a5df1/playground-queen.png 576w", "/static/7113911b86362e6f77f201bc12eebd4d/3cbba/playground-queen.png 1152w", "/static/7113911b86362e6f77f201bc12eebd4d/4dbac/playground-queen.png 1560w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <Caption fullWidth mdxType="Caption">
      <em>(In development. Although <a href="https://billalive.com/how-talk-rock">How to Talk to a Rock</a> is out, you'll want to wait for the revised, much improved second edition.)</em>
    </Caption>
    <h2>{`Humor`}</h2>
    <h3>{`Rich, Skinny, and SUPER Spiritual!`}</h3>
    <p><em parentName="p">{`Transform your ENTIRE LIFE In Just 24 HOURS!! For Real!!!`}</em></p>
    <Row mdxType="Row">
      <Column colMd={8} colLg={8} mdxType="Column">
        <p>{`Meet Alexio Fairfax, self-proclaimed “Internet gazillionaire”.`}</p>
        <p>{`Ready to spill his SUCCESS SECRETS for your TRANSFORMATION!!!`}</p>
        <p>{`He used to be `}<strong parentName="p">{`just like you`}</strong>{`… chained to a cubicle, living off deep-fried pigs’ feet, and trying to fill the void by racking up credit card debt buying antique collectible rototillers he didn’t really need. He was fat, he was broke, and he hadn’t practiced his bassoon in `}<em parentName="p">{`months`}</em>{`.`}</p>
        <p>{`Then `}<strong parentName="p">{`EVERYTHING CHANGED.`}</strong></p>
        <p>{`And he wants to tell you how! Get ready to get RICH, SKINNY, and SUPER SPIRITUAL! All at once! In only 24 hours!! Wow!!!`}</p>
        <p><strong parentName="p">{`DISCLAIMER:`}</strong>{` THIS BOOK IS A PARODY. IT IS NOT A REAL SELF-HELP BOOK.`}</p>
        <p>{`DO NOT TRY ANY OF THIS AT HOME.`}</p>
        <p>{`OR AT WORK. OR ESPECIALLY ON THE WING OF A MOVING AIRPLANE.`}</p>
        <Button size='md' kind='tertiary' href="https://billalive.com/rsw-1" mdxType="Button">Learn more</Button>
      </Column>
      <Column colMd={4} colLg={4} noGutterSm noGutterMd noGutterLg noGutterXl mdxType="Column">
        <ImageGallery mdxType="ImageGallery">
          <ImageGalleryImage alt="Rich, Skinny, and SUPER Spiritual!" title="Rich, Skinny, and SUPER Spiritual!" mdxType="ImageGalleryImage">
            <span {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "971px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "152.77777777777777%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,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')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Rich, Skinny, and SUPER Spiritual!",
                "title": "Rich, Skinny, and SUPER Spiritual!",
                "src": "/static/9836e047437fb18951c774bd368c75a0/0069d/rsw-1.png",
                "srcSet": ["/static/9836e047437fb18951c774bd368c75a0/7fc1e/rsw-1.png 288w", "/static/9836e047437fb18951c774bd368c75a0/a5df1/rsw-1.png 576w", "/static/9836e047437fb18951c774bd368c75a0/0069d/rsw-1.png 971w"],
                "sizes": "(max-width: 971px) 100vw, 971px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy",
                "decoding": "async"
              }}></img>{`
    `}</span>
          </ImageGalleryImage>
        </ImageGallery>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      